import { createSelector } from '@reduxjs/toolkit';

import type { ICategoryLessonSectionList } from '@/Module/HomePage/Model/DataModel';
import { categoryLessonSectionListId } from '@/Module/HomePage/Store/Selector/index';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import { lessonSectionAdapter } from '@/Module/Lesson/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const categoryLessonSectionListCategorySelector = createSelector(
  [
    (state: IState, categoryLessonSectionId: ICategoryLessonSectionList['id']) =>
      categoryLessonSectionListId(state, categoryLessonSectionId),
    (_state: IState, _categoryLessonSectionId: ICategoryLessonSectionList['id'], lessonSectionId: ILessonSection['id']) =>
      lessonSectionId,
  ],
  (categoryLessonSection, lessonSectionId) => {
    if (!categoryLessonSection?.lessonSectionList) return null;
    return lessonSectionAdapter.getSelectors().selectById(categoryLessonSection.lessonSectionList, lessonSectionId);
  },
);
